import type { IconName } from '@blueprintjs/core';
import { Icon as BlueIcon } from '@blueprintjs/core';
import { NavigationContext } from '@layout/navigation/navigation';
import { forwardRef, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Icon,
  Indicator,
  Item,
  Label,
} from '../BeamOnSidebar/BeamOnSidebar.styles';

export interface SidebarItemProps
  extends Omit<React.HTMLProps<HTMLDivElement>, 'children' | 'ref' | 'as'> {
  label: string;
  icon?: IconName;

  iconImage?: React.ReactNode;
  isActive?: boolean;
  isOnlySuperAdmin?: boolean;
}
export function _SidebarItem(
  props: SidebarItemProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const {
    label,
    icon,
    iconImage,
    isActive = false,
    isOnlySuperAdmin,
    ...rest
  } = props;
  const { isSuperAdmin } = useContext(NavigationContext);

  const history = useHistory();

  if (isOnlySuperAdmin && !isSuperAdmin) {
    history.push('/products');

    return <div />;
  }

  return (
    // Todo: semantics
    <Item ref={ref} {...rest}>
      <Indicator data-active={isActive} />
      <Icon>
        {icon && (
          <BlueIcon icon={icon} color={isActive ? '#1371FE' : '#8F95B2'} />
        )}
        {iconImage}
      </Icon>
      <Label>{label}</Label>
    </Item>
  );
}

export const SidebarItem = forwardRef(_SidebarItem);
